import { Col, Row } from 'react-bootstrap'
import Pagination from '../Pagination/Index'

const paginationContainerStyle = {
  color: '#6c757d',
  fontSize: '0.9rem',
  fontWeight: '500'
}

const selectStyle = {
  border: '1px solid #e9ecef',
  borderRadius: '8px',
  padding: '4px 8px',
  fontSize: '0.9rem',
  color: '#495057',
  backgroundColor: '#fff',
  cursor: 'pointer',
  outline: 'none',
  boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
}

function TablePagination(props) {
  const { meta, handleOnChangeMeta, handlePageChange } = props
  return (
    <div className="mt-4 px-2">
      <Row className="align-items-center gap-3 gap-md-0">
        <Col md={6} xs={12}>
          <div
            className="d-flex align-items-center"
            style={paginationContainerStyle}
          >
            <span>Show</span>
            <div className="mx-2">
              <select
                name="per_page"
                aria-label="show-page"
                style={selectStyle}
                value={meta.per_page}
                onChange={(e) => handleOnChangeMeta(e)}
              >
                {[10, 25, 50, 100, 200, 500, 1000].map((value) => (
                  <option key={value} value={value}>
                    {value}
                  </option>
                ))}
              </select>
            </div>
            <span>
              entries &nbsp; <span style={{ color: '#adb5bd' }}>|</span> &nbsp;
              <span className="text-secondary fw-bold">
                {meta.current_page}
              </span>
              &nbsp;to&nbsp;
              <span className="text-secondary fw-bold">{meta.per_page}</span>
              &nbsp;of&nbsp;
              <span className="text-secondary fw-bold">{meta.total_row}</span>
            </span>
          </div>
        </Col>
        <Col md={6} xs={12}>
          <div className="d-flex justify-content-center justify-content-md-end">
            <Pagination
              pageCount={meta.total_page}
              onPageChange={handlePageChange}
              page={meta.current_page}
            />
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default TablePagination
